const FUND_RULES_LINKS = {
  ARHI: [{
    link: '/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  APIA: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  ING: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  SUNCORP: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  AAMI: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  PRICELINE: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  IWHI: [{
    link: 'https://www.nib.com.au/docs/ovhc-fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }, {
    link: 'https://www.nib.com.au/docs/ovhc-duty-of-disclosure',
    text: 'Duty of Disclosure',
    iconType: 'PDF'
  }, {
    link: 'https://www.nib.com.au/health-information/member-services/direct-debit-service-agreement',
    text: 'Direct Debit Service Agreement',
    iconType: 'URL'
  }, {
    link: 'https://www.nib.com.au/docs/vevo-terms',
    text: 'VEVO Terms',
    iconType: 'PDF'
  }],
  IMAN: [{
    link: 'https://www.nib.com.au/docs/iman-fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }, {
    link: 'https://www.austhealth.com/duty-of-disclosure',
    text: 'Duty of Disclosure',
    iconType: 'URL'
  }, {
    link: 'https://www.nib.com.au/docs/iman-direct-debit-request',
    text: 'Direct Debit Service Agreement',
    iconType: 'PDF'
  }, {
    link: 'https://www.nib.com.au/docs/vevo-terms',
    text: 'VEVO Terms',
    iconType: 'PDF'
  }],
  OSHC: [{
    link: '/docs/privacy-policy',
    text: 'Privacy Policy',
    iconType: 'PDF'
  }, {
    link: '/docs/oshc-fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  REAL: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  SENIORS: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  NIBP2PWEB: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  CORPORATE: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }],
  GUHEALTH: [{
    link: 'https://www.nib.com.au/docs/fund-rules',
    text: 'Fund Rules',
    iconType: 'PDF'
  }]
};
export default FUND_RULES_LINKS;